import type { FC } from 'react';
import type { IconProps } from './types';

const MoveBottom: FC<IconProps> = ({ color = 'currentColor', size = 24, strokeWidth = 1.5, ...props }) => {
  const calculatedStrokeWidth = (Number(strokeWidth) * 24) / Number(size);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      color={color}
      fill="none"
      stroke={color}
      strokeWidth={calculatedStrokeWidth}
      {...props}
    >
      <path
        d="M11.9999 22.0001L11.9999 12.0001M11.9999 22.0001C12.5619 22.0001 12.9891 21.562 13.8436 20.6858L15.5 19.0295M11.9999 22.0001C11.4378 22.0001 11.0106 21.562 10.1561 20.6858L8.5 19.0296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="3" cy="3" r="3" transform="matrix(4.37114e-08 1 1 -4.37114e-08 9 2)" />
    </svg>
  );
};

export default MoveBottom;
